import { ref } from 'vue'

const SHOW_DELAY_MS = 150

export const routeLoading = ref(false)

let showTimeout: ReturnType<typeof setTimeout> | null = null

export function startRouteLoading() {
  if (showTimeout) {
    clearTimeout(showTimeout)
  }
  showTimeout = setTimeout(() => {
    routeLoading.value = true
  }, SHOW_DELAY_MS)
}

export function stopRouteLoading() {
  if (showTimeout) {
    clearTimeout(showTimeout)
    showTimeout = null
  }
  routeLoading.value = false
}
